import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Navigation } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-quotes").forEach((el) => {
  const imageSwiper = new Swiper(el.querySelector(".quotes-bg-slider .swiper"), {
    modules: [A11y, EffectFade],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    speed: 750,
    allowTouchMove: false,
  });

  const progressCircle = el.querySelector(".autoplay-progress");

  const start = () => {
    new Swiper(el.querySelector(".quotes-slider .swiper"), {
      modules: [A11y, Autoplay, EffectFade, Navigation],
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      speed: 750,
      allowTouchMove: false,
      navigation: {
        nextEl: el.querySelector(".slider-button-next"),
        prevEl: el.querySelector(".slider-button-prev"),
      },
      on: {
        activeIndexChange: (swiper) => {
          imageSwiper.slideTo(swiper.realIndex);
        },
        autoplayTimeLeft(_, __, progress) {
          if (progressCircle) {
            progressCircle.style.setProperty("--progress", 1 - progress);
          }
        },
      },
    });
  };

  const observer = new IntersectionObserver(
    ([e]) => {
      if (e.isIntersecting) {
        start();
        observer.disconnect();
      }
    },
    {
      threshold: [0.7],
    },
  );

  observer.observe(el);
});
